import { z } from 'zod';

export const ZendeskSettingsSchema = z.object({
  selectedBlockId: z.string().nullable(),
});

export const ZendeskSettingsResponseSchema = z.object({
  selectedBlockId: z.string().nullable().optional(),
});

export type TZendeskSettings = z.infer<typeof ZendeskSettingsSchema>;

// * Shape of a Zendesk Help Center article as Core returns it to the backend sync.
// * Mirrors the Zendesk Help Center Articles API (body is HTML, may be null on drafts).
// * https://developer.zendesk.com/api-reference/help_center/help-center-api/articles/
export const ZendeskKnowledgeArticleSchema = z.object({
  id: z.number(),
  title: z.string(),
  body: z.string().nullable(),
  html_url: z.string(),
  locale: z.string(),
  draft: z.boolean(),
  updated_at: z.string(),
});

export type TZendeskKnowledgeArticle = z.infer<
  typeof ZendeskKnowledgeArticleSchema
>;
